// Understand Bill page translations - Danish
export default {
  breadcrumb: 'Forstå din elregning',
  heroTitle: 'Forstå din elregning',
  heroSubtitle: 'Få klarhed over alle poster på din elregning. Klik på de forskellige elementer for at se forklaringer.',
  heroSubcopy: 'Få klarhed over alle poster på din elregning. Klik på de forskellige elementer for at se forklaringer.',
  clickForExplanations: 'Klik på posterne for at se forklaringer',
  sampleName: 'Anders Jensen',
  sampleAddress1: 'Eksempelvej 42',
  sampleAddress2: '2100 København Ø',
  invoiceDate: 'Fakturadato',
  dueDate: 'Forfaldsdato',
  invoiceNo: 'Faktura nr',
  customerNo: 'Kunde nr',
  meterSection: 'Måler',
  installationAddress: 'Installationsadresse',
  meterPointId: 'Aftagenummer',
  meterNumber: 'Målernummer',
  webPassword: 'Webadgangskode',
  estimatedConsumption: 'Estimeret årsforbrug',
  acontoCalculation: 'Aconto beregning',
  acontoPeriod: 'Din acontobetaling er beregnet for perioden 04-11-2025 til 31-01-2026.',
  product: 'Produkt',
  spotpriceRow: 'Spotpris (285 kWh á 0,8057 kr.)',
  subscriptionRow: 'Abonnement (2,9 mdr. á 18,00 kr.)',
  taxesAndDistribution: 'Afgifter og distribution',
  taxRow: 'Elafgift (285 kWh á 0,697 kr.)',
  transmissionRow: 'Transmissions nettarif (285 kWh á 0,058 kr.)',
  systemTariffRow: 'Systemtarif (285 kWh á 0,054 kr.)',
  systemtariffRow: 'Systemtarif (285 kWh á 0,054 kr.)',
  tsoRow: 'TSO - System Abonnement (2,9 mdr. á 19,14 kr.)',
  netTariffRow: 'Nettarif C (285 kWh á 0,174 kr.)',
  netSubscriptionRow: 'Net abo C forbrug (2,9 mdr. á 45,67 kr.)',
  totalAconto: 'I alt for aconto',
  vatOf: 'Heraf moms (25%)',
  explanations: {
    customer: {
      title: 'Kundeoplysninger',
      description: 'Her finder du dine personlige oplysninger samt vigtige datoer for din regning. Fakturadato er den dato, regningen er udstedt, og forfaldsdato er den dato, betalingen skal være os i hænde.'
    },
    meter: {
      title: 'Måleroplysninger',
      description: 'Din installationsadresse er der, hvor elmåleren er installeret. Aftagenummer er det unikke nummer, der identificerer dit forbrugspunkt i elsystemet. Målernummer identificerer din fysiske elmåler.'
    },
    spotpris: {
      title: 'Spotpris',
      description: 'Dette er prisen for den strøm, du faktisk har brugt. Hos enkel får du 100% børsbaserede priser uden skjulte gebyrer. Prisen varierer baseret på elmarkedet.'
    },
    abonnement: {
      title: 'Abonnement',
      description: 'Dit månedlige abonnement dækker administration, kundeservice og adgang til enkel Saving Mode. Hos enkel har vi Danmarks laveste abonnement fra kun 18 kr./måned.'
    },
    elafgift: {
      title: 'Elafgift',
      description: 'Elafgift er en statslig afgift på elforbrug. Afgiften går til statskassen og er den samme hos alle elselskaber. Bemærk: Du kan få refusion af elafgift på opladning af elbiler - der gælder en række betingelser.'
    },
    transmission: {
      title: 'Transmissions nettarif',
      description: 'Dette er betaling for transport af strøm gennem overordnede højspændingsnet (400 kV og 150 kV). Tariffen går til Energinet, som ejer og driver disse net.'
    },
    systemtarif: {
      title: 'Systemtarif',
      description: 'Systemtarif dækker Energinets omkostninger til at holde elnettet stabilt og i balance, inkl. vedligeholdelse af infrastruktur.'
    },
    tso: {
      title: 'TSO - System Abonnement',
      description: 'TSO står for Transmission System Operator (Energinet). Dette abonnement dækker de faste omkostninger ved at være tilsluttet det danske elsystem.'
    },
    nettarif: {
      title: 'Nettarif C',
      description: 'Dette er din lokale netvirksomheds tarif for distribution af strøm til dit hjem. Tariffen dækker vedligeholdelse og drift af det lokale elnet. "C" henviser til lavspændingsnettet for private husstande.'
    },
    netabo: {
      title: 'Net abonnement C forbrug',
      description: 'Dette er et fast månedligt beløb til din lokale netvirksomhed for at være tilsluttet elnettet. Beløbet varierer afhængigt af, hvilken netvirksomhed der leverer til dit område.'
    },
    total: {
      title: 'I alt for aconto',
      description: 'Dette er det samlede beløb for din acontobetaling i denne periode. Beløbet dækker både din strøm, abonnement, afgifter og tariffer. Din acontobetaling justeres løbende baseret på dit faktiske forbrug.'
    },
    moms: {
      title: 'Moms (25%)',
      description: 'Dansk moms på 25% tillægges alle priser på din elregning. Momsen går til staten og er inkluderet i det samlede beløb til betaling.'
    }
  },
  adviceTitle: 'Gode råd til din elregning',
  advice1Title: 'Brug Betalingsservice',
  advice1Text: 'Tilmeld din elregning til Betalingsservice, så trækkes beløbet automatisk. Du undgår rykkere og gebyrer.',
  advice2Title: 'Tjek din acontobetaling',
  advice2Text: 'Din aconto justeres løbende baseret på dit faktiske forbrug, så du aldrig kommer langt bagud.',
  advice3Title: 'Spar med Saving Mode',
  advice3Text: 'Hvis du har elbil, kan du spare op til 35% på opladning ved at bruge vores gratis Saving Mode funktion.',
  advice4Title: 'Spørgsmål til din regning?',
  advice4Text: 'Vores kundeservice sidder klar til at hjælpe dig med at forstå din regning. Ring på 70 60 80 07.',
  faqSectionTitle: 'Ofte stillede spørgsmål',
  tipsHeader: 'Gode råd til din elregning',
  tip1Header: 'Brug Betalingsservice',
  tip1Body: 'Tilmeld din elregning til Betalingsservice, så trækkes beløbet automatisk. Du undgår rykkere og gebyrer.',
  tip2Header: 'Tjek din acontobetaling',
  tip2Body: 'Din aconto justeres løbende baseret på dit faktiske forbrug, så du aldrig kommer langt bagud.',
  tip3Header: 'Spar med Saving Mode',
  tip3Body: 'Hvis du har elbil, kan du spare op til 30% på opladning ved at bruge vores gratis Saving Mode funktion.',
  tip4Header: 'Spørgsmål til din regning?',
  tip4Body: 'Har du spørgsmål til din regning? Besøg vores support-side for at komme i kontakt med os.',
  faqHeader: 'Ofte stillede spørgsmål',
  billFaq1Q: 'Hvad er forskellen på aconto og endelig afregning?',
  billFaq1A: 'Aconto er en forskudsbetaling baseret på dit estimerede forbrug. Hver gang du får en regning, opgøres dit faktiske forbrug, og du enten får penge retur eller skal betale differencen.',
  billFaq2Q: 'Hvorfor varierer min elregning fra måned til måned?',
  billFaq2A: 'Din regning varierer, fordi spotprisen på el ændrer sig løbende baseret på udbud og efterspørgsel, og fordi dit forbrug varierer. Om vinteren er priserne ofte højere end om sommeren.',
  billFaq3Q: 'Hvad er forskellen på nettarif og abonnement?',
  billFaq3A: 'Nettarif er en variabel omkostning baseret på dit forbrug; abonnement er et fast månedligt beløb.',
  ctaTitle: 'Har du stadig spørgsmål?',
  ctaSubtitle: 'Vores kundeservice sidder klar til at hjælpe dig',
  ctaCall: 'Ring til os: 70 60 80 07',
  ctaEmail: 'Send en e-mail',
  contactSupport: 'Kontakt support',
  backToPortal: 'Tilbage til Support & Kundeportal'
};